module.exports = "/fonts/eppt-picturemark-l-55c15f89f0c37d6930932061849b3366.svg";